var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('nav',{staticClass:"white"},[_c('nav-desktop',{staticClass:"hidden-sm-and-down"}),_c('nav-mobile',{staticClass:"hidden-md-and-up"})],1),_c('marquee-component'),_c('v-main',{staticClass:"white"},[_c('router-view',{key:_vm.currency || 'eur'})],1),_c('cookie'),_c('footer-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }